import { Button, LoadingSpinner, Modal } from '@analytical-alley/ui';

interface Props {
    showModal: boolean;
    isSaving?: boolean;
    onClose: () => void;
    onSave: () => void;
}

export const SaveCampaignDialog = ({
    showModal,
    onClose,
    onSave,
    isSaving = false,
}: Props) => {
    return (
        <Modal dismissible show={showModal} onClose={onClose}>
            <Modal.Header>Save Campaign</Modal.Header>
            <Modal.Body className="text-white">
                <LoadingSpinner show={isSaving} />
                <p>Are you sure you want to save this campaign?</p>
            </Modal.Body>
            <Modal.Footer className="py-4">
                <Button
                    className="ml-2"
                    size="sm"
                    color="light"
                    onClick={onSave}
                >
                    Save
                </Button>
                <Button
                    className="ml-2"
                    size="sm"
                    color="red"
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
